import styled from 'styled-components';

export const RedeemRewardStyled = styled.div`
  border-radius: 16px;
  width: 100%;
  max-width: 350px;
  padding: 18px 12px;
  background: ${({ theme }) => theme.COLORS.WHITE_2};
  .r_reward_img {
    margin-bottom: 16px;
    width: 100%;
    height: auto;
  }
  .redeem_container {
    margin-bottom: 32px;
    width: fit-content;
    .redeem_row {
      .title_red {
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        color: ${({ theme }) => theme.COLORS.RED_1};
      }
      .group_des {
        margin-top: 8px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        color: ${({ theme }) => theme.COLORS.GRAY_6};
        .sub_des {
          font-size: ${({ theme }) => theme.FONT.SIZE.S10};
        }
      }
      .redeem_label {
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        color: ${({ theme }) => theme.COLORS.BLACK_2};
      }
      .redeem_value {
        padding-left: 4px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
        color: ${({ theme }) => theme.COLORS.RED_1};
      }
    }
  }
  .redeem_action_row {
    display: flex;
    column-gap: 16px;
    .redeem_action_col {
      flex: 1;
    }
  }
`;
